import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'rtSimpleFormat',
  standalone: true,
})
export class SimpleFormatPipe implements PipeTransform {
  public transform(value: string): string {
    let transformedValue = value;
    if (value != null && value.length > 0) {
      transformedValue = value
        .replace(/<mailto:.+?>/g, '')
        .replace(/((http|https):\/\/[^\s]+)/g, '<a href="$1" target="_blank">$1</a>')
        .replace(/(\r\n)/g, '\n')
        .replace(/(\n)/g, '<br />');
    }
    return transformedValue;
  }
}
